import React, { useEffect } from "react";
import { datadogRum } from "@datadog/browser-rum";
import { Button, Type } from "mesh-component-library";
import { History } from "history";
import { useLocale } from "../../contexts/LocaleContext";
import { TRANSLATION_CONSTANTS } from "../../app-consts/translations";
import { PartnerDetails } from "../../types";
import { callCustomerServicePhone } from "../../utilities/PhoneUtils";

export type SiteDownProps = {
  chatEnabled: boolean;
  history: History;
  logChatIntakeResults: (payload: string) => void;
  openChatbot: () => void;
  partnerDetails: PartnerDetails;
};

export const SiteDown = ({
  chatEnabled,
  history,
  logChatIntakeResults,
  openChatbot,
  partnerDetails,
}: SiteDownProps) => {
  const getTranslatedText = useLocale();

  useEffect(() => {
    document.title = "Site Down | Roadside Assistance";
  }, []);

  const buttonText = chatEnabled
    ? getTranslatedText(TRANSLATION_CONSTANTS.CHAT_FOR_HELP)
    : getTranslatedText(TRANSLATION_CONSTANTS.CALL_HELP_NOW);

  const handleContactUsClick = () => {
    if (chatEnabled) {
      handleOpenChat();
    } else {
      handlePhoneCall();
    }
  };

  const handleOpenChat = () => {
    logChatIntakeResults("Chat button clicked from Site Down page");
    openChatbot();
  };

  const handlePhoneCall = () => {
    datadogRum.addAction(
      `User called the Customer Service from Sitedown page. Last page was ${history?.location?.pathname}`
    );
    callCustomerServicePhone(partnerDetails.phone, "SiteDown");
  };

  return (
    <div role="main">
      <div className="c-sitedown">
        <svg width="32" height="32" viewBox="0 0 32 32">
          <path
            fill="#CF102D"
            fillRule="evenodd"
            d="M16 0c8.836 0 16 7.164 16 16s-7.164 16-16 16S0 24.836 0 16 7.164 0 16 0zm-.137 23.418c-1.226 0-2.25.993-2.25 2.25a2.25 2.25 0 0 0 4.5 0 2.251 2.251 0 0 0-2.25-2.25zm-.113-2.94c.786 0 1.509-1.27 1.61-2.825l.633-9.83C18.093 6.272 17.083 5 15.75 5c-1.333 0-2.343 1.27-2.243 2.824l.633 9.83c.101 1.554.824 2.824 1.61 2.824z"
          />
        </svg>
        <Type size="3xl" weight="bold" variant="darker">
          {getTranslatedText(TRANSLATION_CONSTANTS.HOW_EMBARRASSING)}
        </Type>
        <Type lineHeight="lg">{getTranslatedText(TRANSLATION_CONSTANTS.TECHNICAL_DIFFICULTIES)}</Type>
        <Button size="lg" hasUpgrade tabIndex={0} id="call-for-help-now" onClick={handleContactUsClick}>
          {buttonText}
        </Button>
        <hr />
      </div>
    </div>
  );
};
